import { CheckedAddress, NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token, TokenConstructorParams } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'

export interface SparkLendTokenParams extends TokenConstructorParams {
  isAToken?: boolean
}

export class SparkLendToken extends Token {
  readonly isAToken: boolean

  constructor(params: SparkLendTokenParams) {
    super(params)
    this.isAToken = params.isAToken ?? false
  }

  createAToken(address: CheckedAddress): SparkLendToken {
    return new SparkLendToken({
      address,
      symbol: TokenSymbol(`sp${this.symbol}`),
      name: this.name,
      decimals: this.decimals,
      logo: this.logo,
      unitPriceUsd: this.unitPriceUsd,
      isAToken: true,
    })
  }

  override clone(overrides: {
    address?: CheckedAddress
    symbol?: TokenSymbol
    name?: string
    decimals?: number
    logo?: string
    unitPriceUsd?: NormalizedNumber
    isAToken?: boolean
  }): SparkLendToken {
    return new SparkLendToken({
      address: overrides.address ?? this.address,
      symbol: overrides.symbol ?? this.symbol,
      name: overrides.name ?? this.name,
      decimals: overrides.decimals ?? this.decimals,
      logo: overrides.logo ?? this.logo,
      unitPriceUsd: overrides.unitPriceUsd ?? this.unitPriceUsd,
      isAToken: overrides.isAToken ?? this.isAToken,
    })
  }
}
